export default import.meta.ROLLUP_FILE_URL_NzPjtVdbB10LywEZ8oqnkg